import { StandardEvents } from '@shopify/events';
// The custom header uses a page cart. Confirm successful additions by opening it.
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  if (!event.promise) return;
  event.promise.then(({cart, detail}) => {
    const badge = document.querySelector('.mm-cart-count');
    if (badge && cart?.totalQuantity !== undefined) badge.textContent = cart.totalQuantity || '';
    if (event.action !== 'add') return;
    if (detail?.didError) return;
    const target = new URL(document.querySelector('.mm-header-right a[aria-label]')?.href || '/cart', location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    location.assign(target.href);
  }).catch(() => { /* Native product form owns error feedback. */ });
});
